import React, { FC, useEffect } from 'react';
import { Button, HStack, Text, VStack } from '@chakra-ui/react';
import { CheckIcon } from '@chakra-ui/icons';
import { useMintState } from '@app/state/mintStore';
import { Address } from '@thirdweb-dev/sdk';
import { StrategyDetails } from '@app/types/plugins';
import { getStrategyAcronim } from '@app/helpers/vaults';

interface Props {
  poolAddress: Address | undefined;
  mintInfo: any;
}

export const StrategySelector: FC<Props> = ({ mintInfo }) => {
  const {
    actions: { setStrategy },
    strategy,
    mode
  } = useMintState();

  useEffect(() => {
    if (mintInfo?.strategies?.length) {
      setStrategy(mintInfo.strategies[0]);
    }
  }, [setStrategy, mintInfo.strategies]);

  function renderViewButton(label: string, _view: StrategyDetails) {
    const isActive = _view.strategyIpfsHash === strategy?.strategyIpfsHash;

    return (
      <Button
        key={_view.vaultAddress}
        variant="tertiary"
        width="fit-content"
        px={10}
        onClick={() => setStrategy(_view)}
        sx={{
          fontSize: 14,
          color: isActive ? 'orange' : 'gray.4',
          bg: isActive ? 'gray.2' : 'transparent',
          textTransform: 'capitalize'
        }}
      >
        {getStrategyAcronim(label)}
      </Button>
    );
  }

  if (mode === 'manual' || !mintInfo?.strategies?.length) {
    return null;
  }

  return (
    <VStack w="100%" gap={4}>
      <HStack
        bg="gray.2"
        borderRadius={4}
        w="100%"
        justifyContent="space-between"
        p={4}
      >
        <Text fontSize={16}>Select a strategy</Text>
        <CheckIcon color="success" width={4} height={4} />
      </HStack>
      <HStack
        width="100%"
        sx={{
          borderRadius: '12px',
          border: '1px solid',
          borderColor: 'gray.5',
          padding: '8px 10px',
          maxWidth: '595px',
          flexWrap: 'wrap'
        }}
      >
        {mintInfo.strategies?.map((strategy: any) =>
          renderViewButton(strategy.strategyName, strategy)
        )}
      </HStack>
    </VStack>
  );
};
